export function setBrowserStyleProperties(document, settings) {
  if (!settings?._id) return;

  document.settings_id = settings._id;

  document.documentElement.style.setProperty("--highlightColor", settings.highlight_color, "important");
  document.documentElement.style.setProperty("--headerColor", settings.top_bar_color, "important");
  document.documentElement.style.setProperty("--headerTextColor", settings.top_bar_text_color, "important");
  document.documentElement.style.setProperty("--leftNavColor", settings.side_bar_color, "important");
  document.documentElement.style.setProperty("--leftNavActiveColor", settings.side_bar_shade_color, "important");
  document.documentElement.style.setProperty("--leftNavTextColor", settings.side_bar_text_color, "important");
  document.documentElement.style.setProperty("--leftNavActiveTextColor", settings.left_nav_active_text_color, "important");
  document.documentElement.style.setProperty("--backgroundColor", settings.background_color || "#fff", "important");
  document.documentElement.style.setProperty("--headerMenuActiveBgColor", settings.header_menu_active_bg_color || "#ffffff", "important");
  document.documentElement.style.setProperty("--headerMenuActiveTextColor", settings.header_menu_active_text_color || "#000000", "important");

  document.querySelector("body").style.backgroundColor = settings.background_color || "#fff";
  document.title = settings.site_name || settings.name || "";

  const metaTitle = document.querySelector("meta[name='title']");
  const metaDescription = document.querySelector("meta[name='description']");

  if (metaTitle) metaTitle.setAttribute("content", settings.login_page_title);
  if (metaDescription) metaDescription.setAttribute("content", settings.login_page_subtitle);

  const favicon = document.querySelector("link[rel*='icon']");
  const appleIcon = document.querySelector("link[rel*='apple-touch-icon']");
  const iconUrl = settings.image_favicon || settings.square_logo;
  const timestampedIconUrl = iconUrl ? `${iconUrl}?${Date.now()}` : "./assets/img/image_favicon-default.png";

  if (favicon) favicon.href = timestampedIconUrl;
  if (appleIcon) appleIcon.href = timestampedIconUrl;
}
